import type { FormikConfig } from "formik";
import { toFormikValidationSchema } from "zod-formik-adapter";

import { z } from "@utils";
import type { IFinancialRule } from "@/components/listBoxes/financialRule";
import type { IShapeOfForm } from "@/utils";

const schema = z.object<IShapeOfForm<IFinancialRule>>({
  visitType: z.dropdown(),
  // TODO min, max??
  visitDuration: z.coerce.number().positive(),
  // TODO min, max??
  price: z.coerce.number().min(0).int(),
  robovPercentage: z.coerce.number().min(0).int(),
});

export const formConfig: FormikConfig<IFinancialRule> = {
  initialValues: {
    id: "",
    visitType: { key: "", value: "" },
    visitDuration: "",
    price: "",
    robovPercentage: "",
  },
  validationSchema: toFormikValidationSchema(schema),
  validateOnChange: true,
  // only here for ts errors.
  onSubmit: () => {},
};
